import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import { isFunction, isString } from '../utils/xp.v1'
import { getBaseDir } from '../utils/app'

Vue.use(Router)

function scrollBehavior() {
  return {
    x: 0,
    y: 0
  }
}

const router = new Router({
  mode: /^https?:\/\//.test(location.href) ? 'history' : 'hash',
  base: getBaseDir(),
  routes,
  scrollBehavior
})

router.afterEach(to => {
  const {
    meta
  } = to
  let title = meta && meta.title
  if (isFunction(title)) {
    const { params, query } = to
    title = title(params || {}, query || {})
  }
  if (isString(title)) {
    document.title = title
  }
})

export default router
